/**
 * Display Armour — Google Reviews Proof Section
 * Structural presentation only; Rocket remains authoritative for live data,
 * links, slide order, controls, pagination and carousel events.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR =
    'div[id^="grp-entangle--root"][id*="rocket_google_reviews_app_block"]';

  function setActionLabel(container, label) {
    var link = container && container.querySelector('a');
    if (!link) return;

    var spans = link.querySelectorAll('span');
    var text = Array.prototype.find.call(spans, function (span) {
      return span.textContent.trim().length > 0;
    });

    if (text) {
      text.textContent = label;
      return;
    }

    var replaced = false;
    Array.prototype.forEach.call(link.childNodes, function (node) {
      if (node.nodeType !== 3 || !node.nodeValue.trim()) return;
      if (!replaced) {
        node.nodeValue = ' ' + label;
        replaced = true;
      } else {
        node.nodeValue = '';
      }
    });

    if (!replaced) link.appendChild(document.createTextNode(label));
  }

  function getDirectActions(root) {
    return Array.prototype.filter.call(root.children, function (child) {
      return child.classList.contains('grp-entangle-write-div');
    });
  }

  function findGoogleMark(root, actions) {
    var mark = actions[1] && actions[1].querySelector('svg');
    if (!mark) mark = root.querySelector('.grp-entangle-source-image svg, .grp-entangle-source-image');
    if (!mark) return null;

    var clone = mark.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('id');
    return clone;
  }

  function getLiveScore(rating) {
    var candidates = [rating.textContent || ''];
    Array.prototype.forEach.call(rating.querySelectorAll('[aria-label], [title]'), function (node) {
      candidates.push(node.getAttribute('aria-label') || '');
      candidates.push(node.getAttribute('title') || '');
    });

    for (var index = 0; index < candidates.length; index += 1) {
      var match = candidates[index].match(/([0-5](?:\.\d+)?)\s*(?:\/\s*5|out of 5)/i);
      if (match) return Number(match[1]).toFixed(1) + ' / 5';
    }

    var fullStars = rating.querySelectorAll('.grp-full-star').length;
    return (fullStars > 0 ? Math.min(fullStars, 5).toFixed(1) : '5.0') + ' / 5';
  }

  function enhance(root) {
    if (!root || root.dataset.daGoogleTrustGrid === 'true') return true;

    var main = root.querySelector('.grp-entangle-layout-body-wrapper');
    var lane = root.querySelector('.grp-entangle-swipper-badge-wrapper');
    var rating = root.querySelector('.grp-entangle-rating-container');
    var actions = getDirectActions(root);

    /* Rocket renders asynchronously; wait for its complete live interface. */
    if (!main || !lane || !rating || actions.length < 2) return false;

    var headingId = root.id + '-title';
    var header = document.createElement('header');
    header.className = 'da-google-trust-grid__header';

    var headingCopy = document.createElement('div');
    headingCopy.className = 'da-google-trust-grid__heading-copy';
    headingCopy.innerHTML =
      '<p class="da-google-trust-grid__eyebrow">Google Verified Reviews</p>' +
      '<h2 id="' + headingId + '">Trusted on Google</h2>' +
      '<p class="da-google-trust-grid__lede">Independent reviews from collectors who trust Display Armour with their collections.</p>';

    /* Protect the final "g" descender from tight theme heading line boxes
       without replacing or altering the current section stylesheet. */
    var heading = headingCopy.querySelector('h2');
    heading.style.setProperty('padding-bottom', '0.12em', 'important');
    heading.style.setProperty('margin-bottom', '-0.12em', 'important');
    heading.style.setProperty('overflow', 'visible', 'important');

    var proof = document.createElement('aside');
    proof.className = 'da-google-trust-grid__proof';
    proof.setAttribute('aria-label', 'Google rating summary');

    var source = document.createElement('div');
    source.className = 'da-google-trust-grid__source';
    var googleMark = findGoogleMark(root, actions);
    if (googleMark) source.appendChild(googleMark);

    var sourceLabel = document.createElement('span');
    sourceLabel.textContent = 'Google Reviews';
    source.appendChild(sourceLabel);

    var ratingLine = document.createElement('div');
    ratingLine.className = 'da-google-trust-grid__rating-line';

    var score = document.createElement('strong');
    score.className = 'da-google-trust-grid__score';
    score.textContent = getLiveScore(rating);

    rating.classList.add('da-google-trust-grid__summary');
    ratingLine.appendChild(score);
    ratingLine.appendChild(rating);

    var actionGroup = document.createElement('div');
    actionGroup.className = 'da-google-trust-grid__actions';
    setActionLabel(actions[1], 'View All Google Reviews →');
    setActionLabel(actions[0], 'Write a Review');

    /* Move Rocket's original links so destinations and event handlers survive. */
    actionGroup.appendChild(actions[1]);
    actionGroup.appendChild(actions[0]);

    proof.appendChild(source);
    proof.appendChild(ratingLine);
    proof.appendChild(actionGroup);
    header.appendChild(headingCopy);
    header.appendChild(proof);

    var reviews = document.createElement('section');
    reviews.className = 'da-google-trust-grid__reviews';
    reviews.setAttribute('aria-label', 'Customer reviews');

    root.insertBefore(header, main);
    reviews.appendChild(main);
    root.appendChild(reviews);

    root.classList.remove('da-google-trust-centre');
    root.classList.add('da-google-trust-grid');
    root.setAttribute('aria-labelledby', headingId);
    root.dataset.daGoogleTrustGrid = 'true';

    /* Rocket measured before the stage became full width. Keep its slider
       instance and request a responsive recalculation after the new layout. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.dispatchEvent(new Event('resize'));
      });
    });

    return true;
  }

  function scan() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(enhance);
  }

  scan();

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
